import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\VQBits_Windows\\fireserve-main\\node_modules\\lucide-react\\dist\\esm\\Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "E:\\VQBits_Windows\\fireserve-main\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\VQBits_Windows\\fireserve-main\\src\\app\\service-detail-page\\components\\ServiceDetailContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\VQBits_Windows\\fireserve-main\\src\\components\\SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\VQBits_Windows\\fireserve-main\\src\\components\\ui\\AppLogo.tsx");
